module.exports = __webpack_public_path__ + "img/banner.d7a8bc0e.png";